import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const AdvisorToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: ${Spacing.S8} 0;

  /**
   * Temporary override: force the ToggleGroup items to share the available
   * width equally (50/50) and prevent label wrapping in the narrow 232px
   * sidebar. Remove this block once the SegmentedControls component is
   * available. The doubled ampersand (&&) is used to beat the specificity of
   * the design-system's internal styles.
   */
  && > div {
    display: flex;
    width: 100%;

    > label {
      flex: 1;
      min-width: 0;

      > div {
        display: flex;
        width: 100%;

        > div {
          flex: 1;
          padding: 0 ${Spacing.S4};
        }
      }
    }
  }
`
